import HeroSection from '../components/HeroSection';
import YouTubeSection from '../components/YouTubeSection';
import MapSection from '../components/MapSection';

function Home() {
  return (
    <div>
      <HeroSection />
      <YouTubeSection />
      <MapSection />
    </div>
  );
}

export default Home; 